import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import * as utils from '@utils'
import { PfSubPfSelect, GameSelect, DateSelect, CompleteDecimal } from '@select'
import { API } from '@const'
import { Grid, Divider, Button } from '@material-ui/core'
import { Search } from '@material-ui/icons'
import ComponentDialog from '@dialogs/component-dialog'
import GameRoundResultPage from './game-round-result-page'
import Table from '@tables/table'

const BET_TYPE_GAME_TYPE_IDX = '3'
const COMPONENT_GROUP = 'bet_game_round_result'

class BetGameRoundResultPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'BetGameRoundResultPage')
        }
    }

    state = {}
    options = { export: false }
    columns = [
        {
            field: 'round_end_at',
            type: 'datetime',
        },
        {
            field: 'game_name',
            translate: {
                dataKey: 'game_code',
                tranKey: 'GameName',
            },
        },
        {
            field: 'round_id',
            render: (rowData) => (
                <Button
                    className={this.props.classes.linkButton}
                    onClick={() =>
                        this.compDialog.OpenDialog(
                            this.t('GameRoundResultPage'),
                            <GameRoundResultPage
                                compDialogArgs={{
                                    dateUnit: 'minute',
                                    searchType: 'round',
                                    roundID: rowData['round_id'],
                                }}></GameRoundResultPage>
                        )
                    }>
                    {rowData['round_id']}
                </Button>
            ),
        },
        {
            field: 'common_result',
            render: (rowData) => {
                if (utils.IsSupportSplitBetRecord(rowData.game_code)) {
                    return utils.GetBetTypeGameCommonResultDisplay(rowData.game_code, rowData['common_result'])
                }

                return ''
            },
            cellStyle: { minWidth: '150px' },
        },
        {
            field: 'bet_amount',
            type: 'numberByThous',
        },
        {
            field: 'bet_valid',
            type: 'currency',
        },
        {
            field: 'profit',
            type: 'currency',
            render: (row, display) => {
                const fontColor = row['profit'] < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
            },
        },
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.options.export = true
        }
    }

    queryData() {
        this.table.SetLoading(true)

        const gameCodeList = []

        if (this.gameSelect.state.gameCode !== 'all') {
            gameCodeList.push(this.gameSelect.state.gameCode)
        } else {
            gameCodeList.push(...this.gameSelect.state.gameList.map((gameInfo) => gameInfo['game_code']))
        }

        const queryParams = {
            pf_id: this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : '',
            pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
            start_date: utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, 'day'),
            end_date: utils.datetimeToUnix_endOf(this.dateSelect.state.endDate, 'day'),
            game_code_list: gameCodeList.join(','),
        }

        utils.apiRequest(
            'get',
            API.BET_RECORD_SUM_LIST_BY_GAME_ROUND,
            queryParams,
            (data) => {
                const currency = utils.getPfCurrency(queryParams['pf_id'])

                data.forEach((elem) => {
                    elem.common_result = JSON.parse(elem.payload)['common_result']
                })

                this.table.SetData(data, currency)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    render() {
        return (
            <Grid container spacing={2}>
                <DateSelect onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                <GameSelect
                    options={{
                        hideGameTypeSelect: true,
                        gameListFilter: (gameInfo) => {
                            return gameInfo['code_id'] === BET_TYPE_GAME_TYPE_IDX
                        }
                    }}
                    onRef={(ref) => (this.gameSelect = ref)}></GameSelect>
                <PfSubPfSelect onRef={(ref) => (this.pfSelect = ref)} options={{hideAllPlatform: true}}></PfSubPfSelect>
                <Grid item>
                    <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                        <Search className={this.props.classes.rightIcon} />
                        {this.t('search')}
                    </Button>
                </Grid>
                <Grid item className={this.props.classes.alignCenter}>
                    <CompleteDecimal />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table ownerName="BetGameRoundResultPage" columns={this.columns} options={this.options} onRef={(ref) => (this.table = ref)} />
                    <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
                </Grid>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        textField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        dateTextField: {
            margin: theme.spacing(1),
            width: '100%',
            minWidth: 120,
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        hide: {
            display: 'none',
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
    }
}

BetGameRoundResultPage.propTypes = {
    classes: PropTypes.object.isRequired,
    dataService: PropTypes.object,
}

export default hoc(styles)(BetGameRoundResultPage)
